module.exports = __webpack_public_path__ + "img/logogp2.6e610cbe.png";